import React from 'react'
import { ContainerColumn } from '../ContainerColumn'
import { FieldComponent } from 'components/Shared/FieldComponent'
import { ContainerRow } from '../ContainerRow'
import { CountrySelectField } from 'components/Shared/CountrySelectField/CountrySelectField'

export function CustomIntermediatePointForm ({ name, disabled }) {
  return (
    <>
      <ContainerColumn>
        <FieldComponent
          fieldName={`${name}.address.address`}
          label='form.order.cargo.customIntermediatePoint.address'
          required
          disabled={disabled}
        />
        <FieldComponent
          fieldName={`${name}.address.city`}
          label='form.order.cargo.customIntermediatePoint.city'
          disabled={disabled}
        />
        <ContainerRow>
          <CountrySelectField
            name={`${name}.address.countryCode`}
            label='form.order.cargo.customIntermediatePoint.country'
            disabled={disabled}
          />
          <FieldComponent
            fieldName={`${name}.address.zipCode`}
            label='form.order.cargo.customIntermediatePoint.zipCode'
            disabled={disabled}
          />
        </ContainerRow>
      </ContainerColumn>
      <ContainerColumn>
        <FieldComponent
          fieldName={`${name}.description`}
          label='form.order.cargo.customIntermediatePoint.description'
          multiline
          rows={5}
          required
          disabled={disabled}
        />
      </ContainerColumn>
    </>
  )
}
